export const publishCustomEvent = <T = unknown>(eventName: string, data?: T) => {
  const event = new CustomEvent(eventName, { detail: data });

  window.dispatchEvent(event);
};
